<template>
  <van-config-provider theme="dark">
    <router-view></router-view>
    <FooterBar v-if="isShow" />
    <div
      class="switchTheme"
      v-if="route.path === '/' && demo === '1'"
      @click="router.push('/switchTheme')"
    >
      <svg
        t="1759492930075"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="5842"
        width="20"
        height="20"
      >
        <path
          d="M515.1 911.758c-161.393 0-260.494-23.495-302.99-71.794-22.442-25.486-21.333-49.521-20.48-56.291 0.455-6.03 15.53-189.924 28.217-275.655-4.608-3.13-14.393-7.054-20.053-9.33a229.831 229.831 0 0 1-13.881-5.888c-18.717-8.79-57.572-28.046-57.572-28.046-48.298-22.187-76.942-50.404-83.996-83.4-5.66-26.424 3.982-49.18 14.876-61.695a40.847 40.847 0 0 1 4.182-4.125L290.475 121.8a39.908 39.908 0 0 1 63.8 17.607c24.89 73.7 97.025 84.736 137.842 84.736 10.866 0 17.778-0.853 17.835-0.882a42.264 42.264 0 0 1 10.553 0.029s6.77 0.825 17.266 0.825c40.021 0 110.79-10.98 135.253-84.566a39.964 39.964 0 0 1 64.085-17.607L960.91 315.676a37.898 37.898 0 0 1 4.125 4.153c10.78 12.516 20.28 35.3 14.592 61.64-7.055 32.824-35.3 60.984-83.94 83.626 0 0.029-37.49 18.887-55.694 27.563-4.096 1.934-8.761 3.868-13.71 5.888-5.519 2.247-15.104 6.144-19.599 9.244 12.573 86.471 27.392 269.881 28.018 277.703 0.683 5.007 1.735 29.184-20.878 54.813-42.325 48.1-140.032 71.452-298.724 71.452zM271.56 786.404c6.712 7.936 48.952 45.425 243.54 45.425 192.228 0 233.188-37.575 239.531-45.312-2.987-35.925-16.384-195.242-27.25-268.686-9.102-61.582 47.531-84.594 68.836-93.24 3.413-1.395 6.656-2.675 9.472-4.011 17.92-8.534 55.097-27.25 55.154-27.279 24.462-11.434 34.474-20.565 38.4-25.287l-175.36-151.78c-52.793 78.194-144.356 87.809-186.084 87.809-9.927 0-17.835-0.54-22.699-0.967a255.602 255.602 0 0 1-22.983 0.967c-42.325 0-135.253-9.671-188.643-88.292l-178.49 152.292c4.068 4.75 14.11 13.71 37.832 24.604 1.138 0.54 38.855 19.285 57.06 27.819 2.872 1.337 6.172 2.645 9.642 4.039 21.59 8.647 78.905 31.602 69.66 93.411-11.178 74.24-24.945 236.345-27.619 268.488z"
          p-id="5843"
          fill="#fff"
        ></path>
      </svg>
    </div>
  </van-config-provider>
</template>
<script setup>
import FooterBar from '@/components/footerBar/index.vue'
import { useMainStore } from '@/store/index'
const demo = import.meta.env.VITE_APP_DEMO
const router = useRouter()
const mainStore = useMainStore()

// 初始化标题和favicon的函数
function initTitleAndFavicon() {
  // 确保 window.__themeEnv 已初始化
  const themeEnv = window.__themeEnv || 'EXMINING'
  let VITE_APP_TITLE = null
  if (themeEnv === 'CICC') {
    VITE_APP_TITLE = '龙兴交易所'
  } else if (themeEnv === 'ARKADEX') {
    VITE_APP_TITLE = 'Arkadex'
  } else if (themeEnv === 'TKBIT') {
    VITE_APP_TITLE = 'TKBIT'
  } else if (themeEnv === 'YT') {
    VITE_APP_TITLE = '元通交易所'
  } else if (themeEnv === 'EXMINING') {
    VITE_APP_TITLE = 'EXMINING交易所'
  } else if (themeEnv === 'CMBIT') {
    VITE_APP_TITLE = 'CMBIT交易所'
  } else {
    VITE_APP_TITLE = import.meta.env.VITE_APP_TITLE
  }
  document.title = import.meta.env.VITE_APP_TITLE

  function setFavicon(iconUrl) {
    let link = document.querySelector("link[rel='icon']")
    if (link) {
      // 如果已经有 favicon 标签，直接替换
      link.href = iconUrl
    } else {
      // 如果没有，创建一个
      link = document.createElement('link')
      link.rel = 'icon'
      link.href = iconUrl
      document.head.appendChild(link)
    }
  }
  // 使用相对路径，解决打包后路径问题
  setFavicon(`./favicon-${themeEnv}.ico`)
}

// 延迟执行，确保 window.__themeEnv 已初始化
if (window.__themeEnv) {
  initTitleAndFavicon()
} else {
  // 如果还没初始化，等待一下
  const checkThemeEnv = setInterval(() => {
    if (window.__themeEnv) {
      initTitleAndFavicon()
      clearInterval(checkThemeEnv)
    }
  }, 10)
  // 设置超时，避免无限等待
  setTimeout(() => {
    clearInterval(checkThemeEnv)
    if (!window.__themeEnv) {
      window.__themeEnv = 'EXMINING'
      initTitleAndFavicon()
    }
  }, 1000)
}

const route = useRoute()
const isShow = computed(() => {
  const list = ['/', '/store', '/flash', '/contract', '/wallet', '/trade', '/flashOption']
  return list.includes(route.path)
})
/**
 * 客服点击监听
 */
const event_serviceChange = () => {
  if (mainStore.getCustomerServiceList.length) {
    if (mainStore.getCustomerServiceList.length == 1) {
      let href = mainStore.getCustomerServiceList[0]?.url
      if (mainStore.getCustomerServiceList[0]?.getUrl) {
        href = mainStore.getCustomerServiceList[0].getUrl()
        window.open(href)
      }
    } else {
      showServicePopup.value = true
    }
  }
}
onMounted(() => {
  document.addEventListener('event_serviceChange', event_serviceChange)
  document.documentElement.setAttribute('data-theme', import.meta.env.VITE_APP_THEME)
})
</script>
<style lang="scss" scoped>
.switchTheme {
  background: var(--van-primary-color);
  padding: 10px;
  border-radius: 50%;
  position: fixed;
  bottom: 200px;
  right: 20px;
  z-index: 9999;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
